"use strict";
/**
 * @module V4Stack
 */
Object.defineProperty(exports, "__esModule", { value: true });
var conversation_id_1 = require("./../conversation/conversation-id");
/**
 * Get the conversation id from the message headers
 *
 * @param  headers  the message headers
 * @return          the conversation ID
 */
function cidFromHeaders(headers) {
    if (!headers || headers.length === 0) {
        throw new Error('Empty headers, expected at least 1');
    }
    return conversation_id_1.ConversationId.fromString(headers[headers.length - 1]);
}
exports.cidFromHeaders = cidFromHeaders;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/v4-stack/headers-tunnel.js
// module id = 1540
// module chunks = 0